import { setDefaultValues, setToTopDimIds } from '../dimensionUtils'
export function createDefaultPivotConfig(dimensions) {
  let chart = 'line-chart'
  let dimOptions = dimensions.dimensionOptions
  let metas = dimensions.dimensionMetas

  let pivotConfig

  pivotConfig = {
    dimensions: Object.keys(dimOptions).map(key => {
      let type = metas[key].type
      let role = type === 'location' ? 'columns' : 'filters'
      return {
        id: key,
        role: role,
      }
    }),
  }

  let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  let bestToRows = filterDims.find(d => metas[d.id].type !== 'time') || filterDims[0]
  bestToRows.role = 'rows'

  Object.keys(metas).forEach(key => {
    if (metas[key].typeOptions.length > 0) {
      pivotConfig.dimensions.push({
        id: key + '_type',
        role: 'types',
      })
    }
  })

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  // let rowsDim = pivotConfig.dimensions.find(d => d.role === 'rows')
  // if (metas[rowsDim.id].type === 'location' && rowsDim.values.length === 1) {
  //   let filterDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  //   if (filterDims.length > 0) {
  //     filterDims = filterDims.slice(0, 2)
  //     filterDims.forEach(d => (d.role = 'rows'))
  //     rowsDim.role = 'filters'
  //   } else {
  //     let colsDim = pivotConfig.dimensions.find(d => d.role === 'columns')
  //     rowsDim.role = 'columns'
  //     colsDim.role = 'rows'
  //   }
  //   setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  // }

  //RELLENAMOS ROWS Y COLS

  // let rowsDims = pivotConfig.dimensions.filter(d => d.role === 'rows')
  let filetrsDims = pivotConfig.dimensions.filter(d => d.role === 'filters')
  let colsDims = pivotConfig.dimensions.filter(d => d.role === 'columns')

  let toCols

  if (colsDims.length === 1 && colsDims[0].values.length === 1) {
    colsDims[0].role = 'filters'
    toCols = filetrsDims.slice(0, 1) // [filetrsDims[0]]
    toCols.forEach(d => (d.role = 'columns'))
    setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)
  }

  setToTopDimIds(pivotConfig, metas)

  setDefaultValues(pivotConfig.dimensions, dimOptions, metas, chart)

  return pivotConfig
}
export function getAvailability(dimensions) {
  let noTimeDims = Object.values(dimensions.dimensionMetas).filter(d => d.type !== 'time')
  if (noTimeDims.length > 1) return { enabled: true, enableable: true }
  else return { enabled: false, enableable: false }
  // let timeDim = Object.values(dimensions.dimensionMetas).find(d => d.type === 'time')
  // if (!timeDim) return { enabled: false, enableable: false }
  // let values = dimensions.dimensionOptions[timeDim.id][0].values
  // if (!values || values.length < 2) return { enabled: false, enableable: false }
  // return { enabled: true, enableable: true }

  //return { enabled: true, enableable: true }
}

export function checkBadData(chartData) {
  return chartData && chartData.every(line => line.every(d => !d[1])) //parece que mejor
}

// export function fixedDimensions(dimensions, metas) {
//   return [
//     dimensions.find(d => {
//       return metas[d.id]?.type === 'time'
//     }),
//   ]
// }
export default {
  getAvailability,
  createDefaultPivotConfig,
  checkBadData,
  // fixedDimensions,
  maxChartDims: 2,
  maxRowDims: 1,
  sdvComponent: 'RadarChart',
}
